import {get as _get} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import {CircularProgress, Backdrop} from '@ui';
import {convertToInt} from '@utils/helpers';
import useQueryCustom from '@utils/hooks/useQueryCustom';
import {GetEventRedirectByMatch} from '@graphql/event/query';

import {EventRedirect} from './EventRedirect';

export function EventRedirectByMatch({
    history,
    match,
}) {
    const {
        data: {
            eventRedirectByMatch,
        } = {},
        error,
        loading: isDataLoading = true,
    } = useQueryCustom({
        query: GetEventRedirectByMatch,
        options: {
            variables: {
                id: convertToInt(match.params.id),
            },
        },
    });

    return (isDataLoading && !error)
        ? (
            <Backdrop open inverted>
                <CircularProgress />
            </Backdrop>
        )
        : (
            <EventRedirect
                errorMessage='match'
                eventContentId={_get(eventRedirectByMatch, 'event_content_id', null)}
                eventId={_get(eventRedirectByMatch, 'event_id', null)}
                history={history}
            />
        );
}

EventRedirectByMatch.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }),
};

export default withRouter(EventRedirectByMatch);
